import { typedFetch, zodValidator } from "~/api/typed-fetch";

import {
  type SystemStatusResponse,
  SystemStatusResponseSchema,
} from "../schemas";

async function getSystemStatus(
  signal?: AbortSignal
): Promise<SystemStatusResponse> {
  return await typedFetch("/opcenter/live-status", {
    validateResponse: zodValidator(SystemStatusResponseSchema),
    signal,
  });
}

export { getSystemStatus };
